/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import Vue from 'vue';
import Cookies from 'js-cookie';

import {
    CHECK,
    REGISTER,
    LOGIN,
    LOGOUT,
} from './mutation-types';

export default {
    [CHECK](state) {
        state.authenticated = Cookies.get('authenticated') == "true";
    },

    [REGISTER]() {
        //
    },

    [LOGIN](state, token) {
        state.authenticated = true;
        //localStorage.setItem('id_token', token);
        Cookies.set('authenticated', 'true', { expires: 1 });
        //Vue.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
    },

    [LOGOUT](state) {
        state.authenticated = false;
        Cookies.remove('authenticated');
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js